import { render, staticRenderFns } from "./headlineBox.vue?vue&type=template&id=fe155508&"
import script from "./headlineBox.vue?vue&type=script&lang=js&"
export * from "./headlineBox.vue?vue&type=script&lang=js&"
import style0 from "./headlineBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports